module.exports = __webpack_public_path__ + "img/kommune-502.9ea30783.svg";